import { render, staticRenderFns } from "./RecipBlockList.vue?vue&type=template&id=0ac42af9&"
import script from "./RecipBlockList.vue?vue&type=script&lang=ts&"
export * from "./RecipBlockList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports